import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ClickableIcon } from '~components';
import { faFileLines } from '~components/icon';
import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

const ItemClaimLinks: React.FC<ComponentProps> = ({ row }) => {
  const navigate = useNavigate();

  if (!row.sah_claim_id) return null;

  return (
    <div className="d-flex gap-1 justify-content-center">
      <ClickableIcon
        id={`si-item-claim-${row.id}`}
        icon={faFileLines}
        toolTip="View Claim"
        ariaLabel="View Claim"
        onClick={() => navigate(`/support-at-home/claims/${row.sah_claim_id}`)}
      />
    </div>
  );
};

export default ItemClaimLinks;
